import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Dropdown from '../../../common/inputs/dropdown/Dropdown';
import DatePicker from '../../../common/inputs/date-picker/DatePicker';
import Button from '../../../common/button/Button';
import Image from '../../../common/image/Image';
import PostContainer from '../../../../containers/common/post/Post.container';

import { ReactComponent as ProfileIcon } from '../../../../resources/icons/profile.svg';

import './market-buzz.scss';

const MarketBuzz = ({
  filters,
  organisations,
  persons,
  profile,
  posts,
  reactions,
  adminRole,
  isLastPostLoaded,
  setIsLastPostLoaded,
  viewPosts,
  navigateToCreatePost,
}) => {
  const [user, setUser] = useState(undefined);
  const [organisation, setOrganisation] = useState(undefined);
  const [datePostedFrom, setDatePostedFrom] = useState(undefined);
  const [datePostedTo, setDatePostedTo] = useState(undefined);

  useEffect(() => {
    setUser(filters.user);
    setOrganisation(filters.organisation);
    setDatePostedFrom(filters.datePostedFrom);
    setDatePostedTo(filters.datePostedTo);
  }, [filters]);

  const haveFiltersChanged = () => {
    let definedKeys = 0;
    for (let key in filters) {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        definedKeys++;
      }
    }

    if (definedKeys !== 0) {
      return true;
    }

    return false;
  };

  const applyFilters = () => {
    const newFilters = {
      ...filters,
      user,
      organisation,
      datePostedFrom,
      datePostedTo,
    };

    viewPosts(newFilters, true);
    setIsLastPostLoaded(false);
  };

  const removeFilters = () => {
    const newFilters = {
      user: undefined,
      organisation: undefined,
      datePostedFrom: undefined,
      datePostedTo: undefined,
    };

    viewPosts(newFilters, true);
    setIsLastPostLoaded(false);
  };

  const handleLoadMoreClick = () => {
    viewPosts(filters);
  };

  return (
    <section className="market-buzz" data-testid="market-buzz">
      <section className="market-buzz__filter">
        <section className="market-buzz__filter__filters">
          <p>Filter</p>

          <label htmlFor="username">Username</label>
          <Dropdown
            name="username"
            value={user}
            options={persons}
            onChange={(option) => setUser(option)}
            getOptionLabel={(option) => option.userName}
            getOptionValue={(option) => option.personExternalReference}
          />

          <label htmlFor="company">Company</label>
          <Dropdown
            name="company"
            value={organisation}
            options={organisations}
            onChange={(option) => setOrganisation(option)}
            getOptionLabel={(option) => option.organizationName}
            getOptionValue={(option) => option.organizationExternalReference}
          />

          <p>Date Posted</p>
          <div className="market-buzz__filter__filters__date-pickers">
            <div>
              <label htmlFor="date-posted-from">From</label>
              <DatePicker
                name="date-posted-from"
                value={datePostedFrom}
                onChange={(date) => setDatePostedFrom(date)}
                maxDate={datePostedTo}
              />
            </div>
            <div>
              <label htmlFor="date-posted-to">To</label>
              <DatePicker
                name="date-posted-to"
                value={datePostedTo}
                onChange={(date) => setDatePostedTo(date)}
                minDate={datePostedFrom}
              />
            </div>
          </div>
        </section>

        <div className="market-buzz__filter__button-container">
          <Button onClick={() => applyFilters()}>Apply Filter</Button>
          {haveFiltersChanged() && <Button onClick={() => removeFilters()}>Remove Filter</Button>}
        </div>
      </section>

      <section className="market-buzz__posts">
        <section className="market-buzz__posts__header">
          <h1>Market Buzz</h1>
        </section>

        <section className="market-buzz__posts__container">
          <div className="market-buzz__create-post-card">
            <div className="market-buzz__create-post-card__profile-picture">
              {profile?.profilePictureExternalReference ? (
                <Image
                  className="market-buzz__create-post-card__profile-picture__image"
                  key={profile.profilePictureExternalReference}
                  externalReference={profile.profilePictureExternalReference}
                  alt=""
                />
              ) : (
                <ProfileIcon />
              )}
            </div>
            <button className="market-buzz__create-post-card__button" onClick={navigateToCreatePost}>
              Create a post...
            </button>
          </div>

          {posts.map((post) => (
            <PostContainer key={post.externalReference} post={post} reactions={reactions} adminRole={adminRole} />
          ))}

          <div className="market-buzz__load-more">
            {isLastPostLoaded ? <p>No more posts to load</p> : <Button onClick={handleLoadMoreClick}>Load More</Button>}
          </div>
        </section>
      </section>
    </section>
  );
};

MarketBuzz.propTypes = {
  filters: PropTypes.shape({}).isRequired,
  organisations: PropTypes.arrayOf(PropTypes.shape({})),
  persons: PropTypes.arrayOf(PropTypes.shape({})),
  profile: PropTypes.shape({}),
  posts: PropTypes.arrayOf(PropTypes.shape({})),
  reactions: PropTypes.arrayOf(PropTypes.shape({})),
  adminRole: PropTypes.bool,
  isLastPostLoaded: PropTypes.bool,
  viewPosts: PropTypes.func.isRequired,
  navigateToCreatePost: PropTypes.func.isRequired,
};

MarketBuzz.defaultProps = {
  organisations: [],
  persons: [],
  profile: undefined,
  posts: [],
  reactions: [],
  adminRole: false,
  isLastPostLoaded: false,
};

export default MarketBuzz;
